export default __webpack_public_path__ + "static/media/dock-close.b19cd716.svg";